const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      marginBottom: "0 !important",
    },
  },
};

export default MuiOutlinedInput;
